import React from 'react';
import './interest info.css'
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { Spin, Button } from "antd";
import { hasValue } from "../../validations/validations";
import { ArrowRightOutlined } from "@ant-design/icons";
import { ActionCardContent, MainCardContent, ModalForAssigned, ModalForUpdateStatus } from './interestInfoDesign';
import { assignedToApi, deleteApi, getInterestHistoryApi, updateStatusApi } from './interestInfoApi';

class interestInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    page: 1,
    pages: 1,
    id: this.props.location.state.data.id,
    fullname: this.props.location.state.data.fullname ? this.props.location.state.data.fullname : '',
    phone: this.props.location.state.data.phone ? this.props.location.state.data.phone : '',
    country: this.props.location.state.data.country ? this.props.location.state.data.country.countryName : null,
    city: this.props.location.state.data.city ? this.props.location.state.data.city : null,
    area: this.props.location.state.data.area ? this.props.location.state.data.area : null,
    direction: this.props.location.state.data.direction ? this.props.location.state.data.direction : null,
    category: this.props.location.state.data.category ? this.props.location.state.data.category : null,
    subCategory: this.props.location.state.data.subCategory ? this.props.location.state.data.subCategory : null,
    company: this.props.location.state.data.company ? this.props.location.state.data.company : 'SAAEI',
    actionUser: this.props.location.state.data.actionUser ? this.props.location.state.data.actionUser : null,
    createdAt: this.props.location.state.data.createdAt,
    status: this.props.location.state.data.status,
    modalForUpdateStatus: false,
    modalType: 'CONTACT',
    clientType: this.props.location.state.data.clientType ? this.props.location.state.data.clientType : '',
    clientStatus: this.props.location.state.data.clientStatus ? this.props.location.state.data.clientStatus : '',
    followUpStatus: this.props.location.state.data.followUpStatus ? this.props.location.state.data.followUpStatus : null,
    noteDescription: this.props.location.state.data.noteDescription ? this.props.location.state.data.noteDescription : '',
    nextContactDate: this.props.location.state.data.nextContactDate ? this.props.location.state.data.nextContactDate : null,
    visitingDate: this.props.location.state.data.visitingDate ? this.props.location.state.data.visitingDate : null,
    visitingEmployee: this.props.location.state.data.visitingEmployee ? this.props.location.state.data.visitingEmployee : null,
    assignedTo: this.props.location.state.data.assignedTo ? this.props.location.state.data.assignedTo : null,
    assignedToId: this.props.location.state.data.assignedTo ? this.props.location.state.data.assignedTo.id : null,
    avgRespondTime: this.props.location.state.data.avgRespondTime ? this.props.location.state.data.avgRespondTime : '--',
    visitnigStatus: this.props.location.state.data.visitnigStatus ? this.props.location.state.data.visitnigStatus : null,
    visitingReport: this.props.location.state.data.visitingReport ? this.props.location.state.data.visitingReport : '',
    priceFrom: 0,
    priceTo: 0,
    paymentType: '',
    contactTime: '',
    users: [],
    cities: [],
    areas: [],
    loading: true,
    modalForVisitingReport: false,
    interestHistory: [],
    modalForAssigned: false,
    categories: [],
    subCategories: [],
    searchData: null,
    bedrooms: null,
    projects: [],
    currentProject: null,
    firstHousing: true
  };
  constructor(props) {
    super(props)
    this.getData()
    this.getInterestHistory(this.props.location.state.data.id)
    this.getUserWithoutPagenation()
    this.getProjects()
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  componentDidMount() {
    if (sessionStorage.getItem('searchData')) {
      let searchData = sessionStorage.getItem('searchData');
      if (searchData != '{}') this.setState({ searchData: searchData })
    }

    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getData = () => {
    axios.get(`${BASE_END_POINT}interests/${this.state.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log('interest  ', response.data)
        this.setState({
          clientType: response.data.data.clientType,
          clientStatus: response.data.data.clientStatus,
          followUpStatus: response.data.data.followUpStatus,
          noteDescription: response.data.data.noteDescription ? response.data.data.noteDescription : "",
          nextContactDate: response.data.data.nextContactDate ? response.data.data.nextContactDate : null,
          visitingDate: response.data.data.visitingDate ? response.data.data.visitingDate : null,
          visitingEmployee: response.data.data.visitingEmployee ? response.data.data.visitingEmployee : null,
          assignedTo: response.data.data.assignedTo ? response.data.data.assignedTo : null,
          ssignedToId: response.data.data.assignedTo ? response.data.data.assignedTo.id : null,
          avgRespondTime: response.data.data.avgRespondTime ? response.data.data.avgRespondTime : '--',
          visitnigStatus: response.data.data.visitnigStatus ? response.data.data.visitnigStatus : null,
          visitingReport: response.data.data.visitingReport ? response.data.data.visitingReport : '',
          fullname: response.data.data.fullname ? response.data.data.fullname : '',
          phone: response.data.data.phone ? response.data.data.phone : '',
          country: response.data.data.country ? response.data.data.country.countryName : null,
          company: response.data.data.company ? response.data.data.company : 'SAAEI',
          actionUser: response.data.data.actionUser ? response.data.data.actionUser : null,
          createdAt: response.data.data.createdAt,
          status: response.data.data.status,
          priceFrom: response.data.data.priceFrom,
          priceTo: response.data.data.priceTo,
          city: response.data.data.city ? response.data.data.city : null,
          area: response.data.data.area ? response.data.data.area : null,
          direction: response.data.data.direction ? response.data.data.direction : null,
          category: response.data.data.category ? response.data.data.category : null,
          subCategory: response.data.data.subCategory ? response.data.data.subCategory : null,
          updatedAt: response.data.data.updatedAt,
          paymentType: response.data.data.paymentType,
          contactTime: response.data.data.contactTime,
          currentProject: response.data.data.currentProject ? response.data.data.currentProject : null,
          project: response.data.data.project ? response.data.data.project : null,
          bedrooms: response.data.data.bedrooms,
          aiRating: response.data.data.aiRating,
          loading: false,
        })
        if (response.data.data.followUpStatus === "DIFFERENT-REQUEST") {
          this.getCities(1)
          this.getCategory()
        }
        //this.getCountry(response.data.data.country ? response.data.data.country.id : 1)
      })
      .catch(error => {
        console.log('interest ERROR  ', error)
        console.log('interest ERROR  ', error.respose)
      })
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  getCountry = (id) => {
    axios.get(`${BASE_END_POINT}countries/${id}`)
      .then(response => {
        console.log("country", response.data.data)
        this.setState({
          phone: this.state.phone.replace(response.data.data.countryCode, "")
        })
      })
      .catch(error => {
        console.log(" country ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/1/cities/withoutPagenation/get?country=${country}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    }).then(response => {
      console.log('cities  ', response.data)
      this.setState({ cities: response.data.data })
    })
      .catch(error => {
        console.log('cities ERROR  ', error)
        console.log('cities ERROR  ', error.respose)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getSubCategory = (category) => {
    axios.get(`${BASE_END_POINT}categories/${category}/sub-categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ subCategories: response.data.data })
      })
      .catch(error => {
        console.log("ALL subCategories ERROR")
        console.log(error.response)
      })
  }
  getUserWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    }).then(response => {
      console.log(response.data.data)
      this.setState({ users: response.data.data })
    })
      .catch(error => {
        console.log("ALL users ERROR")
        console.log(error.response)
      })
  }
  getInterestHistory = async (id) => {
    try {
      const data = await getInterestHistoryApi(id, this.props.currentUser.token, this.props.isRTL);
      this.setState({ interestHistory: data.data });
    } catch (error) {
      console.log('getInterestHistory ERROR ', error);
    }
  };
  delete = async () => {
    try {
      await deleteApi(this.props.location.state.data.id, this.props.currentUser.token, this.props.isRTL, allStrings);
      console.log("interesr DELETED");
      this.props.history.goBack();
    } catch (error) {
      console.log("delete error", error)
    }
  };

  assignedTo = async () => {
    const { id, assignedToId } = this.state
    if (assignedToId != null) {
      try {
        await assignedToApi(id, assignedToId, this.props.currentUser.token, this.props.isRTL, allStrings);
        this.toggleForAssigned()
        this.props.history.goBack()
      } catch (error) {
        console.log(error.response);
      }
    }
  };
  submitHandlerAssigned = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.assignedTo()
  };
  toggleForAssigned = () => {
    this.setState({
      modalForAssigned: !this.state.modalForAssigned,
    });
  }
  updateStatus = async (modalType) => {
    const { id, clientType, clientStatus, followUpStatus, noteDescription } = this.state
    if (hasValue(noteDescription) && clientType != null && clientStatus != null && followUpStatus != null) {
      try {
        let response = await updateStatusApi(modalType, this.state, id, this.props.currentUser.token, this.props.isRTL, allStrings);
        if (response.success == true) {
          this.getData()
          this.getInterestHistory(id)
          this.setState({ modalForUpdateStatus: false })
        }

      } catch (error) {
        console.log("update status error", error);
      }
    }
  };
  submitHandlerUpdateStatus = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.updateStatus()
  };
  toggleForUpdateStatus = (modalType) => {
    this.setState({
      modalType: modalType,
      modalForUpdateStatus: !this.state.modalForUpdateStatus,
    });
  }
  handleChangeState = (fieldName, value) => {
    this.setState({ [fieldName]: value });
  };
  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('INTERESTS')) return <Redirect to='/Home' />
    return (
      <div className="App">
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
          <MDBContainer>
            <ModalForUpdateStatus
              isOpen={this.state.modalForUpdateStatus}
              toggle={this.toggleForUpdateStatus}
              submitHandler={this.submitHandlerUpdateStatus}
              changeHandler={this.changeHandler}
              state={this.state}
              isRTL={this.props.isRTL}
              allStrings={allStrings}
              getCities={this.getCities}
              getAreas={this.getAreas}
              getCategory={this.getCategory}
              getSubCategory={this.getSubCategory}
              getUserWithoutPagenation={this.getUserWithoutPagenation}
              handleChangeState={this.handleChangeState}
            />
            <ModalForAssigned
              isOpen={this.state.modalForAssigned}
              toggle={this.toggleForAssigned}
              submitHandler={this.submitHandlerAssigned}
              changeHandler={this.changeHandler}
              state={this.state}
              isRTL={this.props.isRTL}
              allStrings={allStrings}
              handleChangeState={this.handleChangeState}
            />
            <MDBRow style={{ textAlign: this.props.isRTL ? 'right' : 'left' }}>
              <MDBCol md="12">
                <Button
                  dir={this.props.isRTL ? 'rtl' : 'ltr'}
                  onClick={() => { this.props.history.push("interests", { searchData: JSON.parse(this.state.searchData) }) }}
                  icon={<ArrowRightOutlined />}
                  style={{
                    background: "linear-gradient(90deg, #1D9598, #127275)", color: "white",
                    border: "none", borderRadius: "12px", fontWeight: "500",
                    padding: "0 16px", height: "40px", transition: "all 0.5s ease-in-out"
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "linear-gradient(90deg, #127275, #1D9598)" }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "linear-gradient(90deg, #1D9598, #127275)" }}
                >
                  {allStrings.back}
                </Button>
              </MDBCol>
            </MDBRow>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <MDBCol lg="5" md='12'>
                <div className="infoCard">
                  <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                    <CardMedia style={{ height: "0px" }} />
                    <CardHeader></CardHeader>
                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                      <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                        <span class="material-icons" style={{ color: 'white', fontSize: 20 }}>contact_phone</span>
                      </div>
                      <div className="tableTitle" style={{ display: 'inline-block', marginTop: '-60px', marginLeft: '0', marginRight: '0' }}>
                        <p></p>
                      </div>
                    </div>
                    <MainCardContent
                      state={this.state}
                      isRTL={this.props.isRTL}
                      allStrings={allStrings}
                      history={this.props.history}
                      currentUser={this.props.currentUser}
                      deleteRequest={this.delete}
                      toggleForAssigned={this.toggleForAssigned}
                      toggleForUpdateStatus={this.toggleForUpdateStatus}
                    />
                  </Card>
                </div>
              </MDBCol>
              <ActionCardContent
                state={this.state}
                isRTL={this.props.isRTL}
                allStrings={allStrings}
                history={this.props.history}
                changeHandler={this.changeHandler}
              />
            </MDBRow>
          </MDBContainer>
        </Spin>
      </div>
    )
  }
}
const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};
export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(interestInfo)
);